<p-toast></p-toast>
<app-spinner></app-spinner>
<router-outlet></router-outlet>
<div class="custom-reminder-main"></div>
<app-inactivity-warning></app-inactivity-warning>
